import { Form } from "antd";
import './MarkUserAsPaidPop.css';
import { useContext, useEffect, useState } from "react";
import CustomSingleDropdown from "../../../component/CustomeSigleDropDown";
import FilledButton from "../../../component/FilledButton";
import FormInput from "../../../component/FormInput";
import { ContextState } from "../../../layout";

const MarkUserAsPaidPop = ({ btnLoader, handleDlManualPayment, formDatas, userId, errorData, handleError, category, handleModalClose, setFormRef, startDateDataFromCourse, handleStartDateChange }) => {
    const [form] = Form.useForm();
    const [isAnyChecked, setIsAnyChecked] = useState(false);

    // Track which checkboxes were checked from backend
    const [initialChecked, setInitialChecked] = useState({
        deposit_payment_status_checkbox: !!formDatas?.deposit_payment_status_checkbox,
        first_installment_checkbox: !!formDatas?.first_installment_checkbox,
        second_installment_checkbox: !!formDatas?.second_installment_checkbox,
        full_payment_checkbox: !!formDatas?.full_payment_checkbox,
    });

    const [formData, setFormData] = useState({
        email: formDatas?.email || "",
        deposit_payment_status_checkbox: !!formDatas?.deposit_payment_status_checkbox,
        first_installment_checkbox: !!formDatas?.first_installment_checkbox,
        second_installment_checkbox: !!formDatas?.second_installment_checkbox,
        full_payment_checkbox: !!formDatas?.full_payment_checkbox,
        id: formDatas?.id || "",
    });

    // Reset formData and initialChecked when formDatas or userId changes
    useEffect(() => {
        setFormData({
            email: formDatas?.email || "",
            deposit_payment_status_checkbox: !!formDatas?.deposit_payment_status_checkbox,
            first_installment_checkbox: !!formDatas?.first_installment_checkbox,
            second_installment_checkbox: !!formDatas?.second_installment_checkbox,
            full_payment_checkbox: !!formDatas?.full_payment_checkbox,
            id: formDatas?.id || "",
        });
        setInitialChecked({
            deposit_payment_status_checkbox: !!formDatas?.deposit_payment_status_checkbox,
            first_installment_checkbox: !!formDatas?.first_installment_checkbox,
            second_installment_checkbox: !!formDatas?.second_installment_checkbox,
            full_payment_checkbox: !!formDatas?.full_payment_checkbox,
        });
        // Also reset form fields in antd form
        form.setFieldsValue({
            email: formDatas?.email || "",
            deposit_payment_status_checkbox: !!formDatas?.deposit_payment_status_checkbox,
            first_installment_checkbox: !!formDatas?.first_installment_checkbox,
            second_installment_checkbox: !!formDatas?.second_installment_checkbox,
            full_payment_checkbox: !!formDatas?.full_payment_checkbox,
            id: formDatas?.id || "",
        });
    }, [formDatas, userId]);

    // const initialDisabled = {
    //     deposit_payment_status_checkbox: !!formDatas?.deposit_payment_status_checkbox,
    //     first_installment_checkbox: !!formDatas?.first_installment_checkbox,
    //     second_installment_checkbox: !!formDatas?.second_installment_checkbox,
    //     full_payment_checkbox: !!formDatas?.full_payment_checkbox,
    // };


    form.setFieldsValue(formData);


    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        // Only allow toggling if not initially checked from backend
        if (type === 'checkbox' && initialChecked[name]) {
            // Prevent unchecking if it was checked from backend
            return;
        }

        // Prepare next state for logic
        let nextFormData = {
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        };

        // Apply disabling logic as per requirements
        // 1. When Deposit Payment is pending (not checked): Disable First Installment, Second Installment, Full Payment
        if (name === 'deposit_payment_status_checkbox' && type === 'checkbox') {
            if (!checked) {
                nextFormData = {
                    ...nextFormData,
                    first_installment_checkbox: false,
                    second_installment_checkbox: false,
                    full_payment_checkbox: false,
                };
            }
        }

        // 2. After First Installment is done (checked): Disable Full Payment
        if (name === 'first_installment_checkbox' && type === 'checkbox') {
            if (checked) {
                nextFormData = {
                    ...nextFormData,
                    full_payment_checkbox: false,
                };
            }
        }

        // 3. When Full Payment is done (checked): Disable First Installment and Second Installment
        if (name === 'full_payment_checkbox' && type === 'checkbox') {
            if (checked) {
                nextFormData = {
                    ...nextFormData,
                    first_installment_checkbox: false,
                    second_installment_checkbox: false,
                };
            }
        }

        setFormData(nextFormData);
    };


    const { contextReducer } = useContext(ContextState);
    useEffect(() => {
        const programs = [];
        category?.forEach(item => {
            const newObj = {
                id: item?.programID,
                name: item?.outline[0]?.program_name
            };
            programs.push(newObj);
        });
    }, [category])

    useEffect(() => {
        setFormRef(form);
    }, []);


    // Update isAnyChecked whenever formData changes
    useEffect(() => {
        setIsAnyChecked(
            formData.deposit_payment_status_checkbox ||
            formData.first_installment_checkbox ||
            formData.second_installment_checkbox ||
            formData.full_payment_checkbox
        );
    }, [formData]);

    // Checkbox disabling logic
    const depositPending = !formData.deposit_payment_status_checkbox;
    const firstPaid = formData.first_installment_checkbox;
    const secondPaid = formData.second_installment_checkbox;
    const fullPaid = formData.full_payment_checkbox;

    // Disable rules (add: also disable if initially checked from backend)
    const disableDeposit = initialChecked.deposit_payment_status_checkbox;
    const disableFirst = initialChecked.first_installment_checkbox || depositPending || fullPaid;
    const disableSecond = initialChecked.second_installment_checkbox || depositPending || fullPaid;
    const disableFull = initialChecked.full_payment_checkbox || depositPending || firstPaid;

    return (
        <div className="modal_body">
            <div className="add_thought_leader">
                <Form
                    form={form}
                    name="register"
                    onFinish={(values) => handleDlManualPayment(values, form)}
                    onReset={handleModalClose}
                    scrollToFirstError
                    className="attached_courses-add_skill"
                >
                    <h2>{'Mark User As Paid'}</h2>
                    <Form.Item name="email">
                        <FormInput
                            label="Email *"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            error={errorData['email']}
                            onFocus={(e) => handleError(e)}
                            disabled={true}
                        />
                    </Form.Item>

                    {(contextReducer.cms_type === 'pre-college' || contextReducer.cms_type === 'certificates') && !userId &&
                        <>
                            <CustomSingleDropdown
                                options={category}
                                name="course_name"
                                forlabel='Course(s) *'
                                value={formData.course_name}
                                onChange={handleChange}
                                error={errorData['course_name']}
                                onFocus={() => handleError({ target: { name: "course_name" } })}
                                showSearch
                            />
                            {contextReducer.cms_type === 'certificates' && startDateDataFromCourse?.length === 0 ?
                                "" :
                                <CustomSingleDropdown
                                    options={startDateDataFromCourse}
                                    name="course_start_date"
                                    forlabel='Course start date'
                                    value={formData?.course_start_date}
                                    onChange={handleStartDateChange}
                                    showSearch
                                />
                            }
                        </>
                    }
                    <div className="checkbox-group-paid">
                        <Form.Item
                            name="deposit_payment_status_checkbox"
                            valuePropName="checked"
                            initialValue={formData.deposit_payment_status_checkbox}
                        >
                            <label className="custom-checkbox-label" htmlFor="deposit_payment_status_checkbox">
                                <input
                                    id="deposit_payment_status_checkbox"
                                    type="checkbox"
                                    className="custom-checkbox"
                                    name="deposit_payment_status_checkbox"
                                    checked={formData.deposit_payment_status_checkbox}
                                    onChange={handleChange}
                                    disabled={disableDeposit}
                                />
                                <span className="custom-checkmark"></span>
                                <span>Deposit Payment</span>
                            </label>
                        </Form.Item>
                        <Form.Item
                            name="first_installment_checkbox"
                            valuePropName="checked"
                            initialValue={formData.first_installment_checkbox}
                        >
                            <label className="custom-checkbox-label" htmlFor="first_installment_checkbox">
                                <input
                                    id="first_installment_checkbox"
                                    type="checkbox"
                                    className="custom-checkbox"
                                    name="first_installment_checkbox"
                                    checked={formData.first_installment_checkbox}
                                    onChange={handleChange}
                                    disabled={disableFirst}
                                />
                                <span className="custom-checkmark"></span>
                                <span>First Installment</span>
                            </label>
                        </Form.Item>
                        <Form.Item
                            name="second_installment_checkbox"
                            valuePropName="checked"
                            initialValue={formData.second_installment_checkbox}
                        >
                            <label className="custom-checkbox-label" htmlFor="second_installment_checkbox">
                                <input
                                    id="second_installment_checkbox"
                                    type="checkbox"
                                    className="custom-checkbox"
                                    name="second_installment_checkbox"
                                    checked={formData.second_installment_checkbox}
                                    onChange={handleChange}
                                    disabled={disableSecond}
                                />
                                <span className="custom-checkmark"></span>
                                <span>Second Installment</span>
                            </label>
                        </Form.Item>
                        <Form.Item
                            name="full_payment_checkbox"
                            valuePropName="checked"
                            initialValue={formData.full_payment_checkbox}
                        >
                            <label className="custom-checkbox-label" htmlFor="full_payment_checkbox">
                                <input
                                    id="full_payment_checkbox"
                                    type="checkbox"
                                    className="custom-checkbox"
                                    name="full_payment_checkbox"
                                    checked={formData.full_payment_checkbox}
                                    onChange={handleChange}
                                    disabled={disableFull}
                                />
                                <span className="custom-checkmark"></span>
                                <span>Full Payment</span>
                            </label>
                        </Form.Item>
                    </div>

                    <div class="form_group form_footer d_flex_center">
                        <button type="reset" className="btn btn_gray">cancel</button>
                        <FilledButton
                            type="submit"
                            loading={btnLoader}
                            value={'Submit'}
                            className={`btn ${!isAnyChecked ? 'btn_primary_disabled' : 'btn_primary_enabled'}`}
                            disabled={!isAnyChecked}
                        />
                    </div>
                </Form>
            </div>
        </div>
    )
};

export default MarkUserAsPaidPop;